import { render, staticRenderFns } from "./FlacsDashboard.vue?vue&type=template&id=1762274c&scoped=true"
import script from "./FlacsDashboard.vue?vue&type=script&lang=js"
export * from "./FlacsDashboard.vue?vue&type=script&lang=js"
import style0 from "./FlacsDashboard.vue?vue&type=style&index=0&id=1762274c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1762274c",
  null
  
)

export default component.exports